import { render, staticRenderFns } from "./UserListOfHavingAgencyArchive.vue?vue&type=template&id=12031054&lang=pug"
import script from "./UserListOfHavingAgencyArchive.vue?vue&type=script&lang=js"
export * from "./UserListOfHavingAgencyArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports